import { Component, OnInit } from '@angular/core';
import { AppFilter } from '@app/shared/models';
import { AddGlobalRateLimitModal } from '../../modals/add-global-ratelimit/add-global-ratelimit.component';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { DeleteGlobalRateLimitProfileModal } from '../../modals/delete-global-ratelimit-profile/delete-global-ratelimit-profile.component';
import { RateLimitService } from '../../services/rate-limit.service';
import { SharedService } from '../../services/shared-service.service';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-global-rate-limit',
  templateUrl: './global-rate-limit-settings.component.html',
  styleUrls: ['./global-rate-limit-settings.component.scss'],
})
export class GlobalRateLimitSettings implements OnInit {
  constructor(
    private permissionService: PermissionService,
    private modalService: SuiModalService,
    private rateLimitSvc: RateLimitService,
    private sharedService: SharedService
  ) {}
  filter = new AppFilter();
  totalItems = 0;
  rows = 10;
  maxSize = 10;
  currentPage = 1;
  pending: boolean;
  success;
  error;
  globalRateLimitSettings: any[] = [];

  nextPage(pageNumber: number) {
    this.filter.page = pageNumber;
    this.getGlobalRateLimitSettings();
  }

  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'country',
        op: 'cn',
        data: '',
      },
      {
        field: 'responseMessage',
        op: 'cn',
        data: '',
      },
      {
        field: 'quota',
        op: 'cn',
        data: '',
      },
      {
        field: 'interval',
        op: 'cn',
        data: '',
      },
    ],
  };

  headerFilters = [];
  headers = [
    {
      field: 'country',
      label: 'Country',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'responseMessage',
      label: 'Response Message',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'quota',
      label: 'Quota',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'interval',
      label: 'Interval',
      type: 'text',
      op: 'cn',
      data: '',
    },
  ];

  searchRecords(event) {
    this.searchFilter.rules = this.searchFilter.rules.map((item) => {
      return {
        ...item,
        data: event,
      };
    });
    this.filter._search = true;
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.filter.page = 1;
    this.getGlobalRateLimitSettings();
  }

  displayRecords(row) {
    this.filter['rows'] = row;
    this.currentPage = 1;
    this.getGlobalRateLimitSettings();
  }

  sortRecords(search) {
    this.filter.sord = search;
    this.filter.page = 1;
    this.getGlobalRateLimitSettings();
  }

  advancedSearch(search) {
    if (search) {
      this.filter._search = true;
      this.filter.filters = JSON.stringify(search);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.filter.page = 1;
    this.getGlobalRateLimitSettings();
  }

  cancelAd() {
    this.filter = new AppFilter({
      page: 1,
      rows: this.rows,
      _search: false,
    });

    this.getGlobalRateLimitSettings();
  }

  editGlobalRateLimit(globalRateLimit: any) {
    this.modalService
      .open(
        new AddGlobalRateLimitModal('Add Global Rate Limit', {
          ...globalRateLimit,
          operation: 'edit',
        })
      )
      .onApprove(() => {
        this.getGlobalRateLimitSettings();
      });
  }

  deletGlobalRateLimit(globalRateLimit: any) {
    this.modalService
      .open(
        new DeleteGlobalRateLimitProfileModal(
          'Delete Global Rate Limit Profile',
          {}
        )
      )
      .onApprove(() => {
        this.pending = true;
        this.rateLimitSvc
          .deleteGlobalRateLimitSetting(globalRateLimit.rateLimitCountryId)
          .subscribe(
            (res) => {
              this.success = 'Deleted Successfully';
              this.pending = false;
              this.getGlobalRateLimitSettings();
            },
            (error) => {
              this.error = error.error.errorMessage
                ? error.error.errorMessage
                : error.error.error
                ? error.error.error
                : error.error
                ? error.error
                : error.message
                ? error.message
                : error;
              this.pending = false;
            }
          );
      });
  }

  getGlobalRateLimitSettings() {
    this.pending = true;
    this.rateLimitSvc.getGlobalRateLimitSettings(this.filter).subscribe(
      (res: any) => {
        this.globalRateLimitSettings = res.rows;
        this.totalItems = +res.records;
        this.currentPage = this.filter.rows;
        this.pending = false;
      },
      (error) => {
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error.message
          ? error.message
          : error;
        this.pending = false;
      }
    );
  }

  ngOnInit(): void {
    this.sharedService.globalRateLimitCountryCreatedData$.subscribe((data) => {
      if (data) {
        this.getGlobalRateLimitSettings();
        this.sharedService.updateDate(false);
      }
    });
    this.getGlobalRateLimitSettings();
  }

  parseItem(item: any) {
    if (!item) return;

    return JSON.parse(item);
  }

  checkPermission(event: { id: string; action: string }): boolean {
    const { id, action } = event;
    return this.permissionService.checkPermission(id, action);
  }
}
